import { useEffect } from 'react';
import { usePosCart } from './usePosCart';

interface UsePdpPosCartArgs {
  isLoggedIn?: boolean;
  userCode?: string | number | null;
}

export function usePdpPosCart({ isLoggedIn, userCode }: UsePdpPosCartArgs) {
  const { items, fetchItems, fetchNextPage, hasMore, isLoading } = usePosCart();

  useEffect(() => {
    if (isLoggedIn && userCode) {
      fetchItems({
        customerCode: String(userCode),
        cartItemsOnly: true,
        includeWishlist: false,
        includeWebCart: false,
        page: 1,
        size: 10,
      }).catch((err) => console.error('Failed to load PDP POS cart items:', err));
    }
  }, [isLoggedIn, userCode, fetchItems]);

  return { items, fetchNextPage, hasMore, isLoading };
}
